import React, { Component } from 'react';
import '../../css/chat/chat.css';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';
import { compose } from 'redux';
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

class AiOpts extends Component {
    constructor() {
        super();
        this.wrapperRef = React.createRef();
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.generateShortFormalResonse = this.generateShortFormalResonse.bind(this);
        this.generateShortFriendlyResonse = this.generateShortFriendlyResonse.bind(this);
    }

    componentDidMount() {
        document.addEventListener("mouseup", this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener("mouseup", this.handleClickOutside);
    }

    handleClickOutside(e) {
        if (this.props.showAiOps && this.wrapperRef && !this.wrapperRef.current.contains(e.target) && !this.props.invoker.current.contains(e.target)) {
            this.props.toggleAiOpts();
        }
    }

    generateShortFormalResonse(e) {
        e.preventDefault();
        this.props.generateResponse("formal", "");
    }

    generateShortFriendlyResonse(e) {
        e.preventDefault();
        this.props.generateResponse("friendly", "");
    }

    render() {

        return (

            <div ref={this.wrapperRef} className='position-absolute' style={{ bottom: "80px", left: "160px" }}>
                <div style={{ transform: "none" }} className={"position-relative menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-color py-4 fs-6 w-200px " + (this.props.showAiOps ? "show" : "")} >
                    <div className="menu-item px-5">
                        <a href='/' onClick={this.generateShortFormalResonse} className="menu-link px-5">
                            <span><FontAwesomeIcon icon={duotone("user-tie")} />  {this.props.t("formal")}</span>
                        </a>
                    </div>
                    <div className="menu-item px-5">
                        <a href='/' onClick={this.generateShortFriendlyResonse} className="menu-link px-5">
                            <span><FontAwesomeIcon icon={duotone("face-sunglasses")} />  {this.props.t("friendly")}</span>
                        </a>
                    </div>
                    <div className="menu-item px-5">
                        <a href='/' onClick={this.props.toggleAiResponse} className="menu-link px-5">
                            <span><FontAwesomeIcon icon={duotone("wand-magic-sparkles")} />  {this.props.t("advanced")}</span>
                        </a>
                    </div>
                </div>
            </div>)
    }
}

const mapStateToProps = (state) => {
    return {
    };
};

export default compose(connect(mapStateToProps, {}), withTranslation())(AiOpts);